<template>
  <div class="common-layout">
    <newHeader class="new-header" />
    <div class="content">
      <sidebar v-if="showSidebar"></sidebar>
      <!-- 用于插入其他内容 -->
      <slot></slot>
    </div>
    <newFooter />
  </div>
</template>

<script>
export default {
  name: 'commonLayout',
  props: {
    showSidebar: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.common-layout {
  /* 样式定义 */
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.new-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000; /* 确保在其他内容之上 */
}
.content {
  margin-top: 68px;
}
</style>
